import imagesLoaded from 'imagesloaded';

export default {
  init() {
    console.log(imagesLoaded);

    if ($('.hero').length) {
      $('.hero').each(function () {
        var hero = $(this);
        
        $('.hero__image', hero).imagesLoaded(function () {
          hero.addClass('hero--loaded');
        });
      });
    }
  },
};
